import SeoHead from '../components/SeoHead'

const cardBrands = ['Visa', 'Mastercard', 'Amex', 'Discover', 'Apple Pay', 'Google Pay']

function Badge({ label }) {
  return (
    <span className="bg-white border border-gray-200 rounded-lg px-3 py-2 text-xs font-semibold text-gray-600 text-center">
      {label}
    </span>
  )
}

export default function ResourcesPayments() {
  return (
    <section className="bg-white py-16 px-6">
      <SeoHead
        title="Payments — East County Business Center"
        description="Learn about flexible payment options through Square at East County Business Center in El Cajon, CA — cards, digital wallets, cash, and checks accepted."
        path="/resources/payments"
      />
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold text-ecbc-navy mb-3">Easy, Flexible Payment Options</h1>
        <p className="text-gray-600 leading-relaxed mb-8">
          At East County Business Center, we process all payments securely through Square.
        </p>

        <div className="bg-ecbc-gray rounded-xl p-6 mb-8 flex items-center justify-center text-gray-400 font-semibold">
          {/* TODO: Square logo */}
          Square
        </div>

        <h2 className="text-xl font-bold text-ecbc-navy mb-3">Cards &amp; Digital Wallets</h2>
        <p className="text-gray-500 text-sm mb-4">Accepted online and in person.</p>
        <div className="grid grid-cols-3 sm:grid-cols-6 gap-3 mb-8">
          {cardBrands.map(b => <Badge key={b} label={b} />)}
        </div>

        <h2 className="text-xl font-bold text-ecbc-navy mb-3">Other Payment Methods</h2>
        <ul className="space-y-2 text-gray-600 mb-8">
          <li>• <strong>Cash</strong> — accepted in person during front desk hours (Mon–Fri 9am–12pm)</li>
          <li>• <strong>Check</strong> — payable to East County Business Center; accepted in person</li>
        </ul>

        <div className="bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 mb-8 text-sm text-amber-800">
          We no longer accept PayPal. All card and digital wallet payments are handled through Square.
        </div>

        <h2 className="text-xl font-bold text-ecbc-navy mb-3">How to Pay Online</h2>
        <p className="text-gray-600 leading-relaxed mb-8">
          Pay securely through our website using Square's encrypted checkout. Card information is never stored on our servers.
        </p>

        <h2 className="text-xl font-bold text-ecbc-navy mb-3">Auto-Pay</h2>
        <p className="text-gray-600 leading-relaxed">
          Ask us about setting up recurring monthly payments so you never miss a bill. Contact{' '}
          <a href="mailto:info@eastcountybiz.com" className="text-ecbc-navy font-semibold hover:underline">info@eastcountybiz.com</a>{' '}
          or call <a href="tel:6194014000" className="text-ecbc-navy font-semibold hover:underline">(619) 401-4000</a>.
        </p>
      </div>
    </section>
  )
}
